<div class="row mb-1">
  <div class="col-sm-12">
    <div class="input-group mb-3">
      <span class="input-group-text" id="basic-addon3" i18n>Menge</span>
      <input
        id="count"
        [(ngModel)]="count"
        type="number"
        class="form-control"
        aria-describedby="basic-addon3"
        style="max-width: 50px"
      />
      <button
        class="btn btn-sm btn-primary align-middle"
        [asyncClick]="editCartItem.bind(this)"
        [lockGroup]="cartItemLock"
        [disabled]="saveBtn.disabled"
        #saveBtn="asyncClick"
        type="button"
        i18n
      >
        @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
        Speichern
      </button>
    </div>
  </div>
</div>
<div class="row">
  <div>
    <button
      class="btn btn-sm btn-primary align-middle"
      [asyncClick]="removeCartItem.bind(this)"
      [lockGroup]="cartItemLock"
      [disabled]="removeBtn.disabled"
      #removeBtn="asyncClick"
      type="button"
      i18n
    >
      @if (removeBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Entfernen
    </button>
  </div>
</div>
